/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreatePaymentMethodSetupSessionInput = {
  /** To redirect after payment setup. */
  readonly redirectUrl: string;
};

export type CreateCheckoutSessionMutationVariables = Exact<{
  input: Types.CreatePaymentMethodSetupSessionInput;
}>;

export type CreateCheckoutSessionMutation = { readonly createPaymentMethodSetupSession: string };

export const CreateCheckoutSessionDocument = gql`
  mutation CreateCheckoutSession($input: CreatePaymentMethodSetupSessionInput!) {
    createPaymentMethodSetupSession(input: $input)
  }
`;

export function useCreateCheckoutSessionMutation() {
  return Urql.useMutation<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>(
    CreateCheckoutSessionDocument,
  );
}
